import axios from "../../lib/axiosInstance";

const get = (path, params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );
  return axios.get(`customerDashboard${path}?${q}`).then((r) => r.data);
};

/**
 * The entities and statuses this customer may filter by. The list is resolved
 * server-side from the authenticated user — the UI never decides what is in it.
 */
export const fetchCustomerDashboardFilterOptions = () => get("/filterOptions");

/** Every dashboard panel in one call. */
export const fetchCustomerDashboard = (params) => get("", params);
